import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringShuffler'
})
export class StringShufflerPipe implements PipeTransform {

  transform(value: string): string {

    if (!value) {
      return '';
    } else {
     const a = value.split('');
     const n = a.length;
     for (let i = n - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
     }
      // return value.split('').sort().join('');
      return a.join('');
    }
  }

  private randomize(a, b) {
    return Math.random() > .5 ? -1 : 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/string-shuffler.pipe.ts